import { get, patch } from "../../shared/data";
import { getFilterParams, getSortParams } from "../../shared/helpers";
import { EMPTY_PAGINATION } from "../../shared/constants";

const filterConfig = {
    feedId: "guid",
    upc: "contains",
    statusId: "eq",
    receiveDate: "date",
    turnAroundDate: "date",
};

export const getProducts = (pageNumber, pageSize, sort, filter, activeOnly) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter, filterConfig);
    const activeParam = activeOnly ? "&showActiveOnly=true" : "";

    return get(`/pre-shipment-packages?pagesize=${pageSize}&pagenumber=${pageNumber}${activeParam}${sortBy}${filterBy}`, {
        defaultReturn: { ...EMPTY_PAGINATION },
    });
};

export const getProductExportUrl = (pageNumber, pageSize, sort, filter, suppressError) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter, filterConfig, suppressError);

    return `/pre-shipment-packages/export?pagesize=${pageSize}&pagenumber=${pageNumber}${sortBy}${filterBy}`;
};

export const getProductExport = (url) => {
    return get(url);
};

export const getProductById = (id) => {
    return get(`/pre-shipment-packages/${id}`);
};

export const updateStatusByIds = (items, status, note) => {
    /*
        status: 'Completed'
        status: 'Rejected'
    */
    const withStatusNotes = items.map((i) => {
        return {
            id: i.id,
            feedId: i.feedId,
            status,
            note,
        };
    });

    return patch(`/pre-shipment-packages`, withStatusNotes);
};

export const getStatusList = () => {
    return get("/pre-shipment-lookups/workflow-statuses");
};
